const quarter = {
  1: ["01-01", "03-31"],
  2: ["04-01", "06-30"],
  3: ["07-01", "09-30"],
  4: ["10-01", "12-31"]
};

/**
 * 时间筛选 验证时间区间
 * @type {string}
 */
export const VALIDATE_ERROR = "VALIDATE_ERROR";

const NOT_EMPTY = {
  type: VALIDATE_ERROR,
  msg: "选择时间不能为空"
};
const MAX_DATE_MSG = limit => ({
  type: VALIDATE_ERROR,
  msg: `最长可查询${limit}个月的数据`
});

const MAX_WEEK_MSG = limit => ({
  type: VALIDATE_ERROR,
  msg: `最长可查询${limit}周的数据`
});

const MAX_MONTH_MSG = limit => ({
  type: VALIDATE_ERROR,
  msg: `最长可查询${limit}个月数据`
});
const MAX_QUARTER_MSG = limit => ({
  type: VALIDATE_ERROR,
  msg: `最长可查询${limit}个季度的数据`
});
const MAX_YEAR_MSG = limit => ({
  type: VALIDATE_ERROR,
  msg: `最长可查询${limit}年的数据`
});

export default {
  generate: {
    latestDateRange(limit = 6) {
      const now = new Date();
      let year = now.getFullYear();
      let month = now.getMonth() + 1;
      let day = now.getDate();

      let sixMonthBefore = {};

      if (month >= limit) {
        sixMonthBefore = {
          year,
          month: month - limit + 1,
          day: "01"
        };
      } else {
        sixMonthBefore = {
          year: year - 1,
          month: 12 - (limit - month) + 1,
          day: "01"
        };
      }

      return [`${sixMonthBefore.year}-${formatDig(sixMonthBefore.month)}-01`, `${year}-${formatDig(month)}-${formatDig(day)}`];
    },

    latestMonthDayRange(range = 6) {
      const date = new Date();

      let endYear = date.getFullYear(),
        endMonth = date.getMonth() + 1,
        endDay = date.getDate();

      let startYear = endYear,
        startMonth = endMonth - range,
        startDay = endDay;

      if (startMonth === 0) {
        startMonth = 1;
      }
      else if (startMonth <= 0) {
        startMonth += 12;
        startYear--;
      }

      if (startMonth === 2) {
        if (isLeapYear(startYear)) {
          if (startDay > 29) {
            startDay = 29;
          }
          else if (startDay > 28) {
            startDay = 28;
          }
        }
      }

      return [`${startYear}-${formatDig(startMonth)}-${formatDig(startDay)}`, `${endYear}-${formatDig(endMonth)}-${formatDig(endDay)}`];
    },

    latestWeekRange(year = new Date().getFullYear(), limit = 6, forward = 0) {
      const weeks = getWeeksUntilNow(year, forward);

      let result = [];
      let prev = [];

      const len = weeks.length;

      if (len >= limit) {
        result = weeks.splice(-limit);
      }
      // 当前年到今天 不够六周
      else {
        const prevYearWeeks = getWeeksUntilNow(year - 1,forward);

        result = weeks;
        prev = prevYearWeeks.splice(-(limit - len));
      }

      result = prev.concat(result);

      return [result[0].range[0], result[limit - 1].range[1]];
    },

    latestMonthRange(limit = 6,forward = 0) {
      const now = new Date();
      let year = now.getFullYear();
      let month = now.getMonth() + 1;
      let day = now.getDate();

      month = (year * 12 + month - forward) % 12;
      year = parseInt((year * 12 + month - forward) / 12);
      // year = month ? parseInt(year) : year - 1;
      month = month ? month : 12;

      let sixMonthBefore = {};

      if (month >= limit) {
        sixMonthBefore = {
          year,
          month: month - limit + 1,
          day: "01"
        };
      } else {
        sixMonthBefore = {
          year: year - 1,
          month: 12 - (limit - month) + 1,
          day: "01"
        };
      }
      // beforMonth === 2 && (day >= 28) ? new Date(year, beforMonth, 0).getDate() : day
      return [`${sixMonthBefore.year}-${formatDig(sixMonthBefore.month)}-01`, `${year}-${formatDig(month)}-${formatDig(day)}`];
    },

    nextestMonthRange(limit = 6, startRange = 1) {
      const now = new Date();
      let year = now.getFullYear();
      let month = (now.getMonth() + 1) + startRange;  // 当前月 + 起始间隔月
      let day = now.getDate();

      let sixMonthLater = {};

      const sixMonth = month + (limit % 12) - 1;

      if (sixMonth <= 12) {

        sixMonthLater = {
          year: year + Math.floor(limit / 12),
          month: sixMonth,
          day: "01"
        };

        if (month >= 13) {
          month -= 12;
          year += 1;
        }
      } else {

        sixMonthLater = {
          year: year + 1 + Math.floor(limit / 12),
          month: sixMonth - 12,
          day: "01"
        };

        if (month >= 13) {
          month -= 12;
          year += 1;
        }
      }

      const nextDay = new Date(sixMonthLater.year, sixMonthLater.month, 0);

      return [`${year}-${formatDig(month)}-${formatDig(day)}`, `${sixMonthLater.year}-${formatDig(sixMonthLater.month)}-${nextDay.getDate()}`];
    },

    latestQuarterRange(limit = 6, forward = 0) {
      const today = new Date();
      let endYear = today.getFullYear(),
        endMonth = today.getMonth() + 1;

      let rest = Math.ceil(endMonth / 3);

      rest -= forward;

      if (rest <= 0) {
        rest += 4;
        endYear -= Math.ceil(forward / 4);
      }

      let prevYear, prevQarter;

      if (rest === 1) {
        prevYear = endYear - 2;
        prevQarter = 4;
      }
      else if (rest === 2) {
        prevYear = endYear - 1;
        prevQarter = 1;
      }
      else if (rest === 3) {
        prevYear = endYear - 1;
        prevQarter = 2;
      }
      else if (rest === 4) {
        prevYear = endYear - 1;
        prevQarter = 3;
      }

      return [`${prevYear}-${quarter[prevQarter][0]}`, `${endYear}-${quarter[rest][1]}`];
    },

    latestHalfYearRange(limit = 6, forward = 0) {
      const date = new Date();

      let endYear = date.getFullYear();
      let endMonth = date.getMonth() + 1;
      let startYear,startMonth;

      // 当前时间是否是上半年
      let isFirstHalfYear = endMonth <= 6;

      // 如果提前的值为一年的整数倍
      if (!(forward % 2)) {
        endYear -= forward / 2;
      }
      else {
        // 因为提前了半年的奇数倍，所以结果值的半年的值要反转
        isFirstHalfYear = !isFirstHalfYear;

        endYear -= Math.ceil(forward / 2);
      }

      startYear = endYear - (Math.ceil(limit / 2) - 1);
      endMonth = isFirstHalfYear ? 6 : 12;

      if (limit % 2) {
        startMonth = endMonth;
      }
      else {
        startMonth = endMonth === 6 ? 7 : 1;
      }

      return [`${startYear}-${startMonth}-01`, `${endYear}-${endMonth}-${endMonth === 6 ? "30" : "31"}`];
    },

    latestYearRange(limit = 6,forward = 0) {
      const currYear = new Date().getFullYear();

      return [`${currYear - limit - forward + 1}-01-01`, `${currYear - forward}-12-31`];
    },

    /**
     * 今天
     */
    today() {
      const now = new Date();

      return [formatDate2(now), formatDate2(now)];
    },

    /**
     * 本周（从周一到周日）
     */
    curWeek() {
      const now = new Date();
      const year = now.getFullYear(),
        month = now.getMonth(),
        today = now.getDate(),
        day = now.getDay();
      const Monday = new Date(year, month, today - day + 1).getTime(),
        Sunday = new Date(year, month, today + 7 - day).getTime();

      return [formatDate2(Monday), formatDate2(Sunday)];
    },

    /**
     * 本月
     */
    curMonth() {
      const now = new Date();

      let year = now.getFullYear(),
        month = now.getMonth() + 1;
      let endDate = 30;

      const months = [1,3,5,7,8,10,12];

      if (month === 2) {
        endDate = isLeapYear(year) ? 29 : 28;
      }
      else if (months.includes(month)) {
        endDate = 31;
      }

      return [`${year}-${formatDig(month)}-01`,`${year}-${formatDig(month)}-${endDate}`];
    },

    /**
     * 本季度
     */
    curQuarter() {
      const now = new Date();
      const year = now.getFullYear(),
        month = now.getMonth() + 1;

      const quarters = [[1,2,3],[4,5,6],[7,8,9],[10,11,12]];
      const quarter = quarters.find(item => item.includes(month));

      const months = [3,12];
      let endDate = 30;

      if (months.includes(quarter[2])) {
        endDate = 31;
      }

      return [`${year}-${formatDig(quarter[0])}-01`,`${year}-${formatDig(quarter[2])}-${endDate}`];
    },

    /**
     * 本年
     */
    curYear() {
      const now = new Date();
      const year = now.getFullYear();

      return [`${year}-01-01`,`${year}-12-31`];
    }
  },

  validate: {
    date({ date, limit = 36, msg }) {
      return new Promise((resolve, reject) => {
        if (!date || date.length === 0) {
          reject(NOT_EMPTY);
        }

        const { startYear, startMonth, endYear, endMonth } = splitDateRange(date);

        if (endMonth + (endYear - startYear - 1) * 12 + (12 - startMonth + 1) > limit) {

          msg ? reject({ type: VALIDATE_ERROR, msg }) : reject(MAX_DATE_MSG(limit));
        }

        resolve();
      });
    },

    week({ date, limit = 24, msg }) {
      return new Promise((resolve, reject) => {

        const { startYear, startMonth, startDay, endYear, endMonth, endDay } = splitDateRange(date);

        const start = {
          year: startYear,
          month: startMonth - 1,
          day: startDay
        };

        const end = {
          year: endYear,
          month: endMonth - 1,
          day: endDay
        };

        if (createRangWeeks(start, end).length > limit) {
          msg ? reject({ type: VALIDATE_ERROR, msg }) : reject(MAX_WEEK_MSG(limit));
        }

        resolve();
      });
    },

    month({ date, limit = 36, msg }) {
      return new Promise((resolve, reject) => {
        if (!date || date.length === 0) {
          reject(NOT_EMPTY);
        }

        const { startYear, startMonth, endYear, endMonth } = splitDateRange(date);

        if (endMonth + (endYear - startYear - 1) * 12 + (12 - startMonth + 1) > limit) {
          msg ? reject({ type: VALIDATE_ERROR, msg }) : reject(MAX_MONTH_MSG(limit));
        }

        resolve();
      });
    },

    quarter({ date, limit = 12, msg }) {
      return new Promise((resolve, reject) => {
        if (!date || date.length === 0) {
          reject(NOT_EMPTY);
        }

        const { startYear, startMonth, endYear, endMonth } = splitDateRange(date);

        if (Math.ceil(endMonth / 3) + (endYear - startYear - 1) * 4 + (4 - Math.ceil(startMonth / 3) + 1) > limit) {
          msg ? reject({ type: VALIDATE_ERROR, msg }) : reject(MAX_QUARTER_MSG(limit));
        }

        resolve();
      });
    },

    year({ date, limit = 6, msg }) {
      return new Promise((resolve, reject) => {
        if (!date || date.length === 0) {
          reject(NOT_EMPTY);
        }

        const { startYear, endYear } = splitDateRange(date);

        if (endYear - startYear + 1 > limit) {
          msg ? reject({ type: VALIDATE_ERROR, msg }) : reject(MAX_YEAR_MSG(limit));
        }

        resolve();
      });
    }
  },

  limit: {
    now: function () {
      const date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();

      if (month > 12) {
        year += 1;
        month = 1;
      }
      return [, `${year}-${formatDig(month)}-${formatDig(day)}`];
    },

    range(yearRange = 3) {
      const date = new Date();

      let endYear = date.getFullYear(),
        endMonth = date.getMonth() + 1,
        endDay = date.getDate();

      let startYear = endYear - yearRange,
        startMonth = endMonth + 1,
        startDay = endDay;


      if (startMonth === 0) {
        startYear++;
        startMonth = 1;
      }

      if (isLeapYear(startYear) && startMonth === 2) {
        if (startDay > 29) {
          startDay = 29;
        }
        else if (startDay > 28) {
          startDay = 28;
        }
      }

      return [`${startYear}-${formatDig(startMonth)}-${formatDig(startDay)}`, `${endYear}-${formatDig(endMonth)}-${formatDig(endDay)}`];
    },

    before: function () {
      const date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 2;
      let day = date.getDate();

      if (month > 12) {
        year += 1;
        month = 1;
      }

      return [`${year}-${formatDig(month)}-${formatDig(day)}`];
    },

    start: function (start) {
      let date = null;

      if (start) {
        let tmp = new Date(start.toString()).getTime();

        // 由于start可能只是年份，而new Date(year)出来的时间是早上8点，因此，这里要减8小时 + 1毫秒
        date = new Date(tmp - 1000 * 60 * 60 * 8 - 1);
      }
      else {
        date = new Date();
      }

      let year = date.getFullYear();
      let month = date.getMonth() + 2;
      let day = date.getDate();

      if (month > 12) {
        year += 1;
        month = 1;
      }

      return [`${year}-${formatDig(month)}-${formatDig(day)}`];
    },

    /**
     *
     * @param start 可选时间范围的开始时间戳
     * @param end 可选时间范围的结尾时间戳
     */
    pickerOptions({ start,end }) {
      return  {
        disabledDate(time) {
          return start && time.getTime() < start || end && time.getTime() > end;
        }
      };
    }
  }
};

function splitDateRange(date) {
  const start = date[0].split("-");
  const end = date[1].split("-");

  return {
    startYear: +start[0],
    startMonth: +start[1],
    startDay: +start[2],
    endYear: +end[0],
    endMonth: +end[1],
    endDay: +end[2]
  };
}

function getWeeksUntilNow(year, forward = 0) {
  let today = new Date().getTime();
  today -= forward * 1000 * 60 * 60 * 24 * 7;

  let result = [];
  let index = 1;
  let weeksPerYear = createFullYearWeeks(year);

  for (let i = 0; i < weeksPerYear.length; i++) {
    let start = weeksPerYear[i][0],
      end = weeksPerYear[i][1];

    if (start > today) {
      return result;
    }

    result.push({
      label: `${year}年${index++}周`,
      rangeLabel: `${formatDate(start)}-${formatDate(end)}`,
      value: `${formatDate2(start)}-${formatDate2(end)}`,
      range: [formatDate2(start), formatDate2(end)]
    });
  }

  return result;
}

function formatDig(num) {
  return num > 9 ? "" + num : "0" + num;
}
function formatDate2(mill) {
  var y = new Date(mill);
  return `${y.getFullYear()}-${formatDig(y.getMonth() + 1)}-${formatDig(y.getDate())}`;
}

function formatDate(mill) {
  var y = new Date(mill);
  return `${y.getFullYear()}年${formatDig(y.getMonth() + 1)}月${formatDig(y.getDate())}日`;
}

function createFullYearWeeks(year) {
  let res = [];

  const ONE_DAY = 24 * 3600 * 1000;
  let start = new Date(year, 0, 1),
    end = new Date(year, 11, 31);
  let firstDay = (7 - start.getDay() + 1) % 7 + 1,
    lastDay = (7 - end.getDay()) % 7;

  start = new Date(year, 0, firstDay);
  if (lastDay)end = new Date(year + 1, 0, lastDay);

  let startTime = +start;
  let endTime = startTime + 6 * ONE_DAY;

  while (endTime < end) {
    res.push([startTime, endTime]);
    startTime = endTime + ONE_DAY;
    endTime = endTime + 7 * ONE_DAY;
  }

  res.push([startTime, +end]);
  return res;
}

function createRangWeeks(startDate, endDate) {
  let res = [];

  const ONE_DAY = 24 * 3600 * 1000;
  let start = new Date(startDate.year, startDate.month, startDate.day),
    end = new Date(endDate.year, endDate.month, endDate.day);
  let firstDay = start.getDay() || 7;
  let startTime = +start;
  let endTime = startTime + (7 - firstDay) * ONE_DAY;

  while (endTime < end) {
    res.push([startTime, endTime]);
    startTime = endTime + ONE_DAY;
    endTime = endTime + 7 * ONE_DAY;
  }

  res.push([startTime, +end]);
  return res;
}

function isLeapYear(year) {
  year = parseInt(year);

  return (year % 4 === 0) && (year % 100 !== 0 || year % 400 === 0);
}
